<template>
  <vxe-modal v-model="visible" :title="$t('business.label.orderType')" type="confirm" width="70%" @confirm="confirm">
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.no" placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :loading="loading"
        :min-height="500"
        @checkbox-all="({checked})=>checkAll(checked)"
        @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
        @cell-dblclick="({row})=>dblclick(row)">
        <vxe-column :type="selectType" fixed="left" width="40"/>
        <vxe-column field="no" title="business.label.no" width="100"/>
        <vxe-column field="name" title="business.label.name" width="180"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="refundable" title="business.label.refundable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="shortable" title="business.label.shortable" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="supplemental" title="business.label.supplemental" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="mergeOrder" title="business.label.mergeOrder" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoSubmit" title="business.label.autoSubmit" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoApproval" title="business.label.autoApproval" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoAsn" title="business.label.autoAsn" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoReceiving" title="business.label.autoReceiving" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoAccepting" title="business.label.autoAccepting" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoPutaway" title="business.label.autoPutaway" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===1" field="autoCompletion" title="business.label.autoCompletion" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoRetry" title="business.label.autoRetry" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoInversionApproval" title="business.label.autoInversionApproval" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoReview" title="business.label.autoReview" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoDistribution" title="business.label.autoDistribution" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoHandover" title="business.label.autoHandover" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" :visible="args['operationType']===0||args['operationType']===2" field="autoCleanup" title="business.label.autoCleanup" width="70"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </vxe-modal>
</template>
<script>
import { findAll } from '@/api/Api'

export default {
  name: 'OrderTypeModal',
  props: {
    selectType: { type: String, default: 'radio' }
  },
  data() {
    return {
      visible: false,
      loading: false,
      data: [],
      query: { no: '', name: '' },
      args: { operationType: 0 },
      selectedRows: [],
      record: undefined,
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    init(args) {
      this.query = { no: '', name: '' }
      this.data = []
      this.selectedRows = []
      this.page = 1
      if (args) {
        this.args = args
        Object.assign(this.query, args)
      }
    },
    open(args, e, selectedRows) {
      this.init(args)
      this.record = e
      if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
        this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
      }
      this.visible = true
      this.refresh()
    },
    fetch() {
      this.loading = true
      findAll('orderTypeFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.selectedRows.length > 0) {
            this.$refs.table.setCheckboxRow(this.selectedRows, true)
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { no: '', name: '' }
      Object.assign(this.query, this.args)
      this.refresh()
    },
    dblclick() {
      if (this.selectType === 'radio') {
        this.confirm()
      }
    },
    confirm() {
      let selectedRows
      if (this.selectType === 'radio') {
        const radioRow = this.$refs.table.getRadioRecord()
        if (radioRow !== null) {
          selectedRows = [radioRow]
        } else {
          selectedRows = []
        }
      } else {
        if (this.selectedRows.length > 0) {
          selectedRows = this.selectedRows
        } else {
          selectedRows = this.$refs.table.getCheckboxRecords()
        }
      }
      this.$emit('change', selectedRows, this.record)
      this.visible = false
    },
    closeTag(row) {
      if (row) {
        this.$refs.table.setCheckboxRow(row, false)
      } else {
        this.$refs.table.clearCheckboxRow()
      }
      this.removeSelectedRow(row)
    },
    addTag(row) {
      if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
        this.selectedRows.push(row)
      }
    },
    removeSelectedRow(row) {
      if (row) {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
      } else {
        this.selectedRows = []
      }
    },
    changeCheckbox(checked, row) {
      if (this.selectType === 'radio') {
        return
      }
      if (checked) {
        this.addTag(row)
      } else {
        this.removeSelectedRow(row)
      }
    },
    checkAll(checked) {
      this.data.forEach(item => {
        if (checked) {
          this.addTag(item)
        } else {
          this.closeTag(item)
        }
      })
    }
  }
}
</script>